import React, { FC, useRef } from 'react';
import type { PayallStoryHeroProps } from '@/types';
import { ContentManager } from '../content-manager';
import { Image } from '../image';
import NextImage from 'next/image';
import { TextCols } from '../text-cols';
import { useInView } from '@/hooks/reveal-in-view';

export const PayallStoryHero: FC<PayallStoryHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="payallStoryHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{ title }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            loading="eager"
            fetchPriority="high"
            className="payallStoryHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
            options={{
              sizes: {
                exec: [
                  {
                    width: 1440,
                    height: 594,
                  },
                ],
              },
            }}
          />
        )}
      </div>
      <div className="wrapper" ref={ref}>
        <div className="payallStoryHero--logoWithText">
          <NextImage
            src="/logo-short.svg"
            alt="Logo"
            width={59}
            height={72}
            className="payallStoryHero--logo"
          />
          <ContentManager
            content={description}
            className="payallStoryHero--description"
            style={{
              transform: isInView ? 'none' : `translateY(20px)`,
              opacity: isInView ? 1 : 0,
              transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
            }}
          />
        </div>
      </div>
    </section>
  );
};
